import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-quality",
  "use": "icon-quality-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-quality\"><defs><style type=\"text/css\">@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\r\n</style></defs><path d=\"M662.8864 208.896c-25.7536 33.2288-253.6448 330.496-253.6448 461.1584 0 138.4448 114.6368 250.624 256 250.624 48.64 0 94.1056-13.2608 132.8128-36.352a358.4 358.4 0 0 1-641.024-220.3648c0-197.9392 358.4-663.552 358.4-663.552s69.632 90.4192 147.456 208.5376z\" p-id=\"2977\" /><path d=\"M693.76 841.0112c98.9696 0 179.2-80.0768 179.2-178.8416 0-98.816-179.2-331.1616-179.2-331.1616s-179.2 232.3968-179.2 331.1616a179.0464 179.0464 0 0 0 179.2 178.8416z\" p-id=\"2978\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/quality.svg
// module id = 8mo1
// module chunks = 80